import { connect } from 'react-redux'
import { email, emailOrEmpty } from 'util/validation'
import withFormFields from 'shared/ui/Form/withFormFields'

import { doSwitchInputMode, doSingleInputFormSubmit } from '../actions'
import {
  selectSingleInputFormFields,
  selectInvitationErrors,
  selectBackPageType,
} from '../selectors'

import AddTeamMembersSingleInputFormView from './view'

const validators = {
  emailAddress0Input: email,
  emailAddress1Input: emailOrEmpty,
  emailAddress2Input: emailOrEmpty,
}

const select = state => ({
  initialValues: selectSingleInputFormFields(state),
  validators,
  invitationErrors: selectInvitationErrors(state),
  backPageType: selectBackPageType(state),
})

const perform = {
  switchInputMode: doSwitchInputMode,
  onSave: doSingleInputFormSubmit,
}

export default connect(select, perform)(
  withFormFields(AddTeamMembersSingleInputFormView)
)
